export default {"src":"/_next/static/media/starIcon.1759441d.svg","height":17,"width":16,"blurWidth":0,"blurHeight":0};